import { iseeInstance } from '../axiosService'

class PatientVUService {
  async fetchPatients (portalName, { archived = false } = {}) {
    const params = archived ? '?archived=true' : ''
    return iseeInstance.get(`/patients/portal/${portalName}${params}`)
  }

  async archivePatient (patientId) {
    return iseeInstance.patch(`/patients/${patientId}/archive`)
  }

  async addPatient (
    identifier,
    displayName,
    portalName,
    identifierType = 'identifier',
    birthDate = null,
    gender = '',
    additionalInfo = {}
  ) {
    const { identifier: _i, displayName: _d, portal: _p, identifierType: _t, ...safeAdditionalInfo } = additionalInfo

    const payload = {
      ...safeAdditionalInfo,
      identifier,
      displayName,
      portal: portalName,
      identifierType,
      birthDate: birthDate || null,
      gender: gender || ''
    }

    return iseeInstance.post('/patients', payload)
  }

  async updatePatient (
    patientId,
    identifier,
    displayName,
    portalName,
    identifierType = 'identifier',
    birthDate = null,
    gender = '',
    additionalInfo = {}
  ) {
    const { identifier: _i, displayName: _d, portal: _p, identifierType: _t, ...safeAdditionalInfo } = additionalInfo

    const payload = {
      ...safeAdditionalInfo,
      identifier,
      displayName,
      portal: portalName,
      identifierType,
      birthDate: birthDate || null,
      gender: gender || ''
    }

    return iseeInstance.put(`/patients/${patientId}`, payload)
  }

  async deletePatient (patientId) {
    return iseeInstance.delete(`/patients/${patientId}`)
  }

  async linkPatientToSession (patientId, sessionId) {
    return iseeInstance.patch('/patients/link-session', {
      patientId,
      sessionId
    })
  }

  async getPatientById (patientId) {
    return iseeInstance.get(`/patients/${patientId}`)
  }

  async getPatientSessions (patientId) {
    return iseeInstance.get(`/patients/${patientId}/sessions`)
  }
}

export default new PatientVUService()
